import { useState,useEffect } from 'react';
import { Box, Card, Checkbox, Grid, Typography, useTheme } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import SpeedIcon from '@mui/icons-material/Speed';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
const CardItemServiciosModal = ({
    item,
    servicioSelect,
    setServicioSelect,
    coberturaMaxima,
    permisoEsp,
    disabledPrefa = false,
    permisoPrefa
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [mbBajada, setmbBajada] = useState(0)
    const [precio, setPrecio] = useState(0)
    useEffect(() => {
        const splite = item?.bajada?.split('.')
        if(splite?.length > 0){
            setmbBajada(splite[0])
        }
    }, [item])
    const onClickCard = () =>{
        if(coberturaMaxima >= mbBajada || permisoEsp){
            setServicioSelect({...item,prefactibilidad: 'POSITIVA'})
        }else if(!disabledPrefa && permisoPrefa){
            if(item?.tipo?.trim() === 'PY'){
                setServicioSelect({...item, prefactibilidad: 'NEGATIVA'})
            }
        }
    }
    useEffect(() => {
        if(item?.precio){
            const numero = Number(item?.precio)
            if(!isNaN(numero)){
                setPrecio(Math.round(numero * 100) / 100);
            }
        }
    }, [item])

    return (
        <Card
            sx={{
                background: servicioSelect?.cod_producto === item?.cod_producto
                    ? item?.tipo_descripcion === 'NUBI PyMES'
                        ? 'linear-gradient(135deg, #ff9f43 0%, #ff8008 100%)'
                        : 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)'
                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? isDarkMode ? 'linear-gradient(135deg, rgba(255, 159, 67, 0.15) 0%, rgba(255, 128, 8, 0.1) 100%)' : 'linear-gradient(135deg, #fff8f0 0%, #fff5e8 100%)'
                            : isDarkMode ? 'linear-gradient(135deg, #2d3a52 0%, #1F2A40 100%)' : 'linear-gradient(135deg, #fafbfd 0%, #f5f8fc 100%)'
                        : isDarkMode ? 'linear-gradient(135deg, #1F2A40 0%, #1a2332 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                border: servicioSelect?.cod_producto === item?.cod_producto 
                    ? item?.tipo_descripcion === 'NUBI PyMES'
                        ? '2px solid #ffb84d'
                        : '2px solid #42a5f5'
                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? isDarkMode ? '2px solid rgba(255, 184, 77, 0.3)' : '2px solid #ffe4c4'
                            : isDarkMode ? '2px solid #3d4a62' : '2px solid #dce8f5'
                        : isDarkMode ? '2px solid #3d4a62' : '2px solid #dee2e6',
                borderRadius: '12px',
                boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                    ? item?.tipo_descripcion === 'NUBI PyMES'
                        ? '0 4px 16px rgba(255, 159, 67, 0.2), 0 0 0 1px rgba(255, 184, 77, 0.1) inset'
                        : '0 4px 16px rgba(30, 136, 229, 0.2), 0 0 0 1px rgba(66, 165, 245, 0.1) inset'
                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? '0 1px 6px rgba(255, 159, 67, 0.06)'
                            : '0 1px 6px rgba(100, 150, 200, 0.06)'
                        : '0 1px 4px rgba(0,0,0,0.04)',
                mt: 0.75,
                transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY')) 
                    ? 'pointer' 
                    : 'not-allowed',
                '&:hover':{
                    transform: (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                        ? 'translateY(-2px)'
                        : 'none',
                    boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                        ? item?.tipo_descripcion === 'NUBI PyMES'
                            ? '0 6px 20px rgba(255, 159, 67, 0.25), 0 0 0 1px rgba(255, 184, 77, 0.2) inset'
                            : '0 6px 20px rgba(30, 136, 229, 0.25), 0 0 0 1px rgba(66, 165, 245, 0.2) inset'
                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                ? '0 2px 12px rgba(255, 159, 67, 0.1), 0 0 0 1px #ffdbb8'
                                : '0 2px 12px rgba(100, 150, 200, 0.1), 0 0 0 1px #d4e4f7'
                            : '0 1px 4px rgba(0,0,0,0.04)'
                },
                position: 'relative',
                overflow: 'hidden'
            }}
            onClick={()=>onClickCard()}
        >
            {/* Indicador de selección - Barra superior con brillo */}
            {servicioSelect?.cod_producto === item?.cod_producto && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '3px',
                        background: item?.tipo_descripcion === 'NUBI PyMES'
                            ? 'linear-gradient(90deg, #ffb84d 0%, #ffc870 50%, #ffb84d 100%)'
                            : 'linear-gradient(90deg, #42a5f5 0%, #64b5f6 50%, #42a5f5 100%)',
                        backgroundSize: '200% 100%',
                        animation: 'shimmer 2s ease-in-out infinite',
                        zIndex: 1,
                        '@keyframes shimmer': {
                            '0%': { backgroundPosition: '-200% 0' },
                            '100%': { backgroundPosition: '200% 0' }
                        }
                    }}
                />
            )}

            {/* Badge de Deshabilitado Mejorado */}
            {!(coberturaMaxima >= mbBajada || permisoEsp || (servicioSelect?.cod_producto === item?.cod_producto && servicioSelect?.prefactibilidad === 'NEGATIVA')) && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        px: 1.5,
                        py: 0.5,
                        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)',
                        borderRadius: '15px',
                        boxShadow: '0 2px 8px rgba(255, 107, 107, 0.3)',
                        zIndex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                >
                    <Box
                        sx={{
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            backgroundColor: '#fff',
                            animation: 'pulse 2s ease-in-out infinite',
                            '@keyframes pulse': {
                                '0%, 100%': { opacity: 1 },
                                '50%': { opacity: 0.4 }
                            }
                        }}
                    />
                    <Typography
                        sx={{
                            color: '#fff',
                            fontSize: 8,
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.6px'
                        }}
                    >
                        Sin Cobertura
                    </Typography>
                </Box>
            )}

            <Grid container spacing={1} sx={{p: {xs: 1, sm: 1.5}}}>
                {/* Checkbox */}
                <Grid item xs={2} sm={1.5} md={1} display='flex' justifyContent='center' alignItems='flex-start' sx={{pt: 0.5}}>
                    <Checkbox
                        checked={servicioSelect?.cod_producto === item?.cod_producto}
                        icon={
                            <Box
                                sx={{
                                    width: 22,
                                    height: 22,
                                    border: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '2px solid #ffdbb8'
                                        : '2px solid #d4e4f7',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    backgroundColor: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? (isDarkMode ? 'rgba(255, 184, 77, 0.1)' : '#fff8f0')
                                        : (isDarkMode ? '#1F2A40' : '#f0f6fc'),
                                    '&:hover': {
                                        borderColor: item?.tipo_descripcion === 'NUBI PyMES'
                                            ? '#ffb84d'
                                            : '#64b5f6',
                                        backgroundColor: item?.tipo_descripcion === 'NUBI PyMES'
                                            ? 'rgba(255, 184, 77, 0.12)'
                                            : 'rgba(100, 181, 246, 0.12)',
                                        transform: 'scale(1.05)'
                                    }
                                }}
                            >
                                <RadioButtonUncheckedOutlinedIcon sx={{fontSize: 0}} />
                            </Box>
                        }
                        checkedIcon={
                            <Box
                                sx={{
                                    width: 22,
                                    height: 22,
                                    background: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? 'linear-gradient(135deg, #ff9f43 0%, #ffb84d 100%)'
                                        : 'linear-gradient(135deg, #1e88e5 0%, #42a5f5 100%)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: item?.tipo_descripcion === 'NUBI PyMES'
                                        ? '0 2px 8px rgba(255, 159, 67, 0.4), 0 0 0 2px rgba(255, 184, 77, 0.2)'
                                        : '0 2px 8px rgba(30, 136, 229, 0.4), 0 0 0 2px rgba(66, 165, 245, 0.2)',
                                    animation: 'checkPulse 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                                }}
                            >
                                <CheckCircleIcon sx={{color: '#fff', fontSize: 16}} />
                            </Box>
                        }
                        sx={{
                            p: 0,
                            '&:hover': {
                                backgroundColor: 'transparent'
                            }
                        }}
                    />
                </Grid>

                {/* Contenido Principal */}
                <Grid item xs={10} sm={10.5} md={11}>
                    <Box display='flex' flexDirection='column' gap={0.3}>
                        {/* Tipo/Categoría con Icono y Badge */}
                        <Box display='flex' alignItems='center' gap={0.6}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 20,
                                    height: 20,
                                    borderRadius: '6px',
                                    background: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.25)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? (isDarkMode ? 'rgba(255, 184, 77, 0.15)' : 'linear-gradient(135deg, #fff5e8 0%, #ffeccc 100%)')
                                                : (isDarkMode ? 'rgba(30, 136, 229, 0.15)' : 'linear-gradient(135deg, #e8f2fa 0%, #d9e9f7 100%)')
                                            : (isDarkMode ? 'rgba(158, 158, 158, 0.1)' : 'rgba(158, 158, 158, 0.15)')
                                }}
                            >
                                <SignalCellularAltIcon 
                                    sx={{
                                        fontSize: 12,
                                        color: servicioSelect?.cod_producto === item?.cod_producto
                                            ? '#fff'
                                            : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                                ? item?.tipo_descripcion === 'NUBI PyMES'
                                                    ? (isDarkMode ? '#fbbf24' : '#d4940f')
                                                    : (isDarkMode ? '#90caf9' : '#5b8fc4')
                                                : (isDarkMode ? '#757575' : '#9e9e9e')
                                    }}
                                />
                            </Box>
                            <Typography 
                                sx={{
                                    color: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.95)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? (isDarkMode ? '#fbbf24' : '#d4940f')
                                                : (isDarkMode ? '#90caf9' : '#6b95c1')
                                            : (isDarkMode ? '#757575' : '#9e9e9e'),
                                    fontSize: {xs: 9, sm: 10},
                                    fontWeight: 700,
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase'
                                }} 
                                variant='caption'
                            >
                                {item?.tipo_descripcion}
                            </Typography>
                        </Box>

                        {/* Nombre del servicio */}
                        <Typography 
                            sx={{
                                color: servicioSelect?.cod_producto === item?.cod_producto
                                    ? '#fff'
                                    : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                        ? (isDarkMode ? '#e0e0e0' : '#202124')
                                        : (isDarkMode ? '#9e9e9e' : '#757575'),
                                fontWeight: 700,
                                fontSize: {xs: 13, sm: 14, md: 15},
                                lineHeight: 1.3
                            }} 
                            variant='h4'
                        >
                            {item?.nombre}
                        </Typography>

                        {/* Chips de Velocidad y Precio */}
                        <Box display='flex' alignItems='center' gap={1} flexWrap='wrap' sx={{mt: 0.5}}>
                            {/* Chip de Velocidad */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    px: 1.5,
                                    py: 0.5,
                                    background: servicioSelect?.cod_producto === item?.cod_producto
                                        ? 'rgba(255, 255, 255, 0.2)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? (isDarkMode ? 'rgba(255, 184, 77, 0.15)' : 'linear-gradient(135deg, #fff8f0 0%, #fff0db 100%)')
                                                : (isDarkMode ? 'rgba(30, 136, 229, 0.15)' : 'linear-gradient(135deg, #f0f6fc 0%, #e8f1fb 100%)')
                                            : (isDarkMode ? '#1F2A40' : 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)'),
                                    borderRadius: '20px',
                                    border: servicioSelect?.cod_producto === item?.cod_producto
                                        ? '1px solid rgba(255, 255, 255, 0.3)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? (isDarkMode ? '1px solid rgba(255, 184, 77, 0.3)' : '1px solid #ffdbb8')
                                                : (isDarkMode ? '1px solid #3d4a62' : '1px solid #d4e4f7')
                                            : (isDarkMode ? '1px solid #3d4a62' : '1px solid #e9ecef'),
                                    boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                                        ? '0 2px 6px rgba(255, 255, 255, 0.1)'
                                        : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? '0 1px 4px rgba(255, 159, 67, 0.1)'
                                                : '0 1px 4px rgba(100, 150, 200, 0.1)'
                                            : 'none'
                                }}
                            >
                                <SpeedIcon 
                                    sx={{
                                        fontSize: 14,
                                        color: servicioSelect?.cod_producto === item?.cod_producto
                                            ? 'rgba(255, 255, 255, 0.9)'
                                            : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                                ? item?.tipo_descripcion === 'NUBI PyMES'
                                                    ? (isDarkMode ? '#fbbf24' : '#d4940f')
                                                    : (isDarkMode ? '#90caf9' : '#6b95c1')
                                                : (isDarkMode ? '#757575' : '#bdbdbd')
                                    }}
                                />
                                <Typography 
                                    sx={{
                                        color: servicioSelect?.cod_producto === item?.cod_producto
                                            ? '#fff'
                                            : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                                ? (isDarkMode ? '#e0e0e0' : '#202124')
                                                : (isDarkMode ? '#9e9e9e' : '#9e9e9e'),
                                        fontWeight: 700,
                                        fontSize: {xs: 12, sm: 13},
                                        lineHeight: 1
                                    }}
                                >
                                    {mbBajada}
                                </Typography>
                                <Typography 
                                    sx={{
                                        fontSize: {xs: 9, sm: 10},
                                        fontWeight: 600,
                                        color: servicioSelect?.cod_producto === item?.cod_producto
                                            ? 'rgba(255, 255, 255, 0.8)'
                                            : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                                ? item?.tipo_descripcion === 'NUBI PyMES'
                                                    ? (isDarkMode ? '#fbbf24' : '#e0b054')
                                                    : (isDarkMode ? '#90caf9' : '#8ba8c5')
                                                : (isDarkMode ? '#757575' : '#bdbdbd')
                                    }}
                                >
                                    {item?.unidad_bajada}
                                </Typography>
                            </Box>

                            {/* Chip de Precio */}
                            {precio > 0 && (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 0.5,
                                        px: 1.5,
                                        py: 0.5,
                                        background: servicioSelect?.cod_producto === item?.cod_producto
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? 'linear-gradient(135deg, #ffb84d 0%, #ff9f43 100%)'
                                                : 'linear-gradient(135deg, #42a5f5 0%, #1e88e5 100%)'
                                            : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                                ? item?.tipo_descripcion === 'NUBI PyMES'
                                                    ? 'linear-gradient(135deg, #ff9f43 0%, #ff8008 100%)'
                                                    : 'linear-gradient(135deg, #1e88e5 0%, #1976d2 100%)'
                                                : 'linear-gradient(135deg, #ced4da 0%, #adb5bd 100%)',
                                        borderRadius: '20px',
                                        boxShadow: servicioSelect?.cod_producto === item?.cod_producto
                                            ? item?.tipo_descripcion === 'NUBI PyMES'
                                                ? '0 2px 8px rgba(255, 184, 77, 0.3)'
                                                : '0 2px 8px rgba(66, 165, 245, 0.3)'
                                            : (coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY'))
                                                ? item?.tipo_descripcion === 'NUBI PyMES'
                                                    ? '0 1px 6px rgba(255, 159, 67, 0.2)'
                                                    : '0 1px 6px rgba(30, 136, 229, 0.2)'
                                                : '0 1px 4px rgba(173, 181, 189, 0.2)'
                                    }}
                                >
                                    <AttachMoneyIcon 
                                        sx={{
                                            fontSize: 14,
                                            color: '#fff'
                                        }}
                                    />
                                    <Typography 
                                        sx={{
                                            color: '#fff',
                                            fontWeight: 700,
                                            fontSize: {xs: 12, sm: 13},
                                            lineHeight: 1
                                        }}
                                    >
                                        ${precio}
                                    </Typography>
                                    <Typography 
                                        sx={{
                                            color: 'rgba(255, 255, 255, 0.8)',
                                            fontSize: {xs: 9, sm: 10},
                                            fontWeight: 500
                                        }}
                                    >
                                        /mes
                                    </Typography>
                                </Box>
                            )}
                        </Box>

                        {/* Alerta Sin Cobertura */}
                        {servicioSelect?.cod_producto === item?.cod_producto && servicioSelect?.prefactibilidad === 'NEGATIVA' && (
                            <Box
                                sx={{
                                    mt: 0.5,
                                    p: 0.8,
                                    backgroundColor: isDarkMode ? 'rgba(255, 107, 107, 0.15)' : '#fff5f5',
                                    border: isDarkMode ? '1px solid rgba(255, 107, 107, 0.3)' : '1px solid #feb2b2',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 0.2
                                }}
                            >
                                <Box display='flex' alignItems='center' gap={0.4}>
                                    <Box
                                        sx={{
                                            width: 14,
                                            height: 14,
                                            borderRadius: '50%',
                                            backgroundColor: '#fc8181',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontSize: 9,
                                            fontWeight: 700
                                        }}
                                    >
                                        !
                                    </Box>
                                    <Typography 
                                        sx={{
                                            color: isDarkMode ? '#ff6b6b' : '#c53030',
                                            fontWeight: 700,
                                            fontSize: {xs: 8, sm: 9}
                                        }}
                                    >
                                        SIN COBERTURA
                                    </Typography>
                                </Box>
                                <Typography 
                                    sx={{
                                        color: isDarkMode ? '#ff8787' : '#742a2a',
                                        fontSize: {xs: 7, sm: 8},
                                        lineHeight: 1.4,
                                        ml: 2.2
                                    }}
                                >
                                    Se solicitará un estudio de prefactibilidad en RF y FO.
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Grid>
            </Grid>

            {/* Animación CSS */}
            <style>
                {`
                    @keyframes checkPulse {
                        0% { transform: scale(0.8); }
                        50% { transform: scale(1.1); }
                        100% { transform: scale(1); }
                    }
                `}
            </style>
        </Card>
    )
}

export default CardItemServiciosModal